import { Component, computed, input } from '@angular/core';

import { CommonModule } from '@angular/common';

import { CoreService } from '../core.service'
import { Team } from '../app.models';

@Component({
	selector: 'app-team',
	imports: [ CommonModule ],
	templateUrl: './team.component.html',
	styleUrl: './team.component.scss'
})
export class TeamComponent {
	constructor( public core: CoreService ){}

	team = input<Team>();
	score = input<number>(null);
	is_spoilable = input<boolean>(false);

	get t(){ return this.team() }//  = computed(() => this.team());



	//Score spoiler sticker random rotation
	_transform_style: string = null;
	get transform_style(){
		if( this._transform_style !== null ) return this._transform_style;
		let d = Math.random() * 30 - 15;
		this._transform_style = `rotate(${d}deg)`;
		return this._transform_style;
	}
}
